import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {useLoadIntegrityTurn} from '../hooks/index';

const IntegrityTurnGrid = (props: any) => {
  const loadTurn = useLoadIntegrityTurn(props.data.key);

  return (
    <IntegrityRoleGrid
      allowEdit={Roles.AdminITPS}
      dataSource={loadTurn}
      id={['iD_Shift']}
      integrityId={['ID_Shift']}
      integrityName={'Shift'}
      exportName="Shift-export"
      height={'30vh'}
      allowIntegrity={false}
      allowActions={false}
      disabledExport={true}
      autoWidth={false}
    >
      <Column caption={i18n2._('#Shift')} dataField="iD_Shift" />
      <Column caption={i18n2._('Nombre')} dataField="name" />
      <Column caption={i18n2._('Horario')} dataField="schedule" />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        defaultSortOrder={'desc'}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default IntegrityTurnGrid;
